// extracted by mini-css-extract-plugin
export default {"portfolio":"styles_portfolio__DvYoy"};